import React from 'react';
import { useLocation } from 'react-router';

import { Header } from 'components/Header';

import './screenWrapperComponent.scss';
import { NavLink } from 'react-router-dom';

export const ScreenWrapperComponent: React.FC<React.PropsWithChildren> = (
  props
) => {
  const location = useLocation();
  const showUserMenu =
    location.pathname !== '/forgot-password' &&
    location.pathname !== '/reset-password' &&
    location.pathname !== '/' &&
    location.pathname !== '/invite-user';

  return (
    <div className='screen-wrapper'>
      <Header
        backgroundAccent={location.pathname === '/home'}
        showMenu={showUserMenu}
      />
      {props.children}
      {showUserMenu && location.pathname !== '/help' && (
        <NavLink to='/help' className='help-link'>
          ?
        </NavLink>
      )}
    </div>
  );
};
